import React from 'react'
import { Cards } from '../../components'

import './product-page.scss'

export const ProductPage = ({title, data, bgImg}: any) => {
    return (
        <>
            <div className='header-product' style={{backgroundImage: `url('/images/${bgImg}')`}}>
                <div>
                    <p>{title}</p>
                    <h1>Луксозни. Уникални. Ваши.</h1>
                    <p>Ръчно изработени с внимание към детайла</p>
                </div>
            </div>
            <Cards data={data}/>
        </>
    )
}
